/* =============================================================
   JMM Comment ça marche — ligne de progression + point voyageur.
   Démarre quand la section entre à l'écran, cycle automatique
   (pause au survol), survol d'une étape = saut direct.
   ============================================================= */
(function () {
  'use strict';

  function initSteps(root) {
    if (root.hasAttribute('data-jms-init')) return;
    root.setAttribute('data-jms-init', '1');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var steps = Array.prototype.slice.call(root.querySelectorAll('.jms__step'));
    var fill = root.querySelector('.jms__fill');
    var dot = root.querySelector('.jms__dot');
    var line = root.querySelector('.jms__line');
    var track = root.querySelector('.jms__track');
    if (!steps.length || !track) return;

    var centers = [];
    var vertical = false;
    var mqV = window.matchMedia('(max-width: 749px)');
    function measure() {
      if (!line || !dot) return;
      vertical = mqV.matches;
      var tr = track.getBoundingClientRect();
      var rects = steps.map(function (s) {
        var ic = s.querySelector('.jms__ic') || s;
        return ic.getBoundingClientRect();
      });
      if (vertical) {
        centers = rects.map(function (r) { return r.top - tr.top + r.height / 2; });
        line.style.left = '';
        line.style.right = '';
        line.style.top = centers[0] + 'px';
        line.style.bottom = (tr.height - centers[centers.length - 1]) + 'px';
        fill.style.width = '100%';
        dot.style.left = '';
      } else {
        centers = rects.map(function (r) { return r.left - tr.left + r.width / 2; });
        line.style.top = '';
        line.style.bottom = '';
        line.style.left = centers[0] + 'px';
        line.style.right = (tr.width - centers[centers.length - 1]) + 'px';
        fill.style.height = '';
        fill.style.width = '0%';
        dot.style.top = '';
      }
    }
    measure();
    window.addEventListener('resize', function () { measure(); go(idx, true); });

    var idx = 0;
    var paused = false;
    var started = false;

    function go(i, instant) {
      idx = i;
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k <= i); });
      if (!fill || !dot || !centers.length) return;
      var span = centers[centers.length - 1] - centers[0];
      var p = span > 0 ? (centers[i] - centers[0]) / span * 100 : 0;
      if (instant) {
        fill.style.transition = 'none';
        dot.style.transition = 'none';
      }
      if (vertical) {
        fill.style.height = p + '%';
        dot.style.top = (centers[i] - 6) + 'px';
      } else {
        fill.style.width = p + '%';
        dot.style.left = (centers[i] - 6) + 'px';
      }
      if (instant) {
        void fill.offsetWidth;
        fill.style.transition = '';
        dot.style.transition = '';
      }
    }

    if (reduce || !root.hasAttribute('data-jms-auto')) {
      go(steps.length - 1, true);
      steps.forEach(function (s) { s.classList.add('is-on'); });
      if (reduce) return;
    }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    steps.forEach(function (s, k) {
      s.addEventListener('mouseenter', function () { go(k); });
    });

    if (!root.hasAttribute('data-jms-auto')) return;

    var speed = (parseInt(root.getAttribute('data-jms-speed'), 10) || 2200);
    function startCycle() {
      if (started) return;
      started = true;
      go(0, true);
      window.setInterval(function () {
        if (paused) return;
        var next = (idx + 1) % steps.length;
        if (next === 0) {
          steps.forEach(function (s, k) { s.classList.toggle('is-on', k === 0); });
          go(0, true);
        } else {
          go(next);
        }
      }, speed);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { startCycle(); io.disconnect(); }
        });
      }, { threshold: .35 });
      io.observe(root);
    } else {
      startCycle();
    }
  }

  function initAll() { document.querySelectorAll('.jms').forEach(initSteps); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initAll, 0); });
})();
